<div class="redeem-overlay" *ngIf="visible">
    <div class="redeem-overlay__backdrop"></div>
    <div class="redeem-overlay__dialog">
        <div class="redeem-overlay__header">
            <div class="redeem-overlay__header__title">
                <ensemble-icon name="lock"></ensemble-icon>
                <span class="font-b1 font-medium">Redeem Credit To View</span>
            </div>
            <en-btn style="--en-content-primary: var(--en-content-default);" kind="tertiary" type="button" *ngIf="showCloseButton" class="redeem-overlay__close" (click)="close()">
                <i class="icon icon-x" aria-hidden="true"></i>
            </en-btn>
        </div>
        <div class="redeem-overlay__content">
            <p>Use <b class="font-weight-bold"> 1 credit </b> to access this report. You have {{ availableCredits }} credits left to spend.</p>
        </div>
        <div class="redeem-overlay__actions">
            <en-btn size="sm" type="button" (click)="confirm()">Use 1 Credit
            <i class="icon icon-check ml-1"></i>
            </en-btn>
        </div>
    </div>
</div>
